var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[_c('span',{staticClass:"signal signal-block-l"}),(!_vm.hideLabel)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.label))}}):_vm._e(),(!_vm.hideLabel)?_c('span',[_vm._v("...")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }